import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "q-pa-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_my_page_select_box = _resolveComponent("my-page-select-box");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_my_page_select_box, {
            modelValue: _ctx.selectedRoom,
            "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedRoom) = $event)),
                _ctx.onChangeList
            ],
            selectList: _ctx.bukenRoomList,
            dense: "",
            style: { "font-size": "18px" }
        }, null, 8, ["modelValue", "selectList", "onUpdate:modelValue"])
    ]));
}
